import React from "react"

const PosContext = React.createContext({})

export const PosProvider = PosContext.Provider
export const PosConsumer = PosContext.Consumer

export default PosContext
